var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-box bgff"},[_c('div',{staticClass:"menu"},_vm._l((_vm.menuList),function(item,index){return _c('div',{key:index,staticClass:"inner cursor",class:{
        'menu-click': item.path == _vm.$route.path || item.path == _vm.$route.meta.menu,
        },on:{"click":function($event){return _vm.linkGo(item, index)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }